import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/myInvite',
  component: LAYOUT,
  name: 'MyInvite',
  redirect: '/myInvite/index',
  meta: {
    title: '超级合伙人',
  },
  children: [
    {
      path: 'index',
      name: 'MyInviteIndex',
      meta: {
        title: '超级合伙人',
      },
      component: () => import('@/views/myInvite/index'),
    },
    {
      path: 'rule',
      name: 'MyInviteRule',
      meta: {
        title: '活动规则',
      },
      component: () => import('@/views/myInvite/rule'),
    },
    {
      path: 'share',
      name: 'MyInviteShare',
      meta: {
        title: '邀请海报',
      },
      component: () => import('@/views/myInvite/share'),
    },
  ],
};
